import { GridRowData, GridRowsProp } from '@mui/x-data-grid';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { QuickSearchField } from './QuickSearchField';

export interface ClientQuickSearchProps {
  rows: GridRowsProp;
  setRows: Dispatch<SetStateAction<GridRowsProp>>;
  excludedColumns?: Nullable<string[]>;
  enableColumnSearch?: boolean;
}

const escapeRegExp = (value: string): string => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

export const GridClientQuickSearch: React.FC<ClientQuickSearchProps> = ({ rows, setRows, excludedColumns, enableColumnSearch }) => {
  const [searchText, setSearchText] = useState<string>('');

  const clientSideFilter = (searchValue: string): GridRowsProp => {
    // Check for column-specific search syntax (column:value) if enabled
    if (enableColumnSearch) {
      const colonIndex = searchValue.indexOf(':');
      if (colonIndex > 0) {
        const column = searchValue.substring(0, colonIndex).trim();
        const value = searchValue.substring(colonIndex + 1).trim();

        if (value) {
          const searchRegex: RegExp = new RegExp(escapeRegExp(value), 'i');
          return rows.filter((row: GridRowData) => row[column] && searchRegex.test(row[column]?.toString()));
        }
      }
    }

    // Default behavior: search across all non-excluded columns
    const searchRegex: RegExp = new RegExp(escapeRegExp(searchValue), 'i');
    return rows.filter((row: GridRowData) =>
      Object.keys(row)
        .filter((column) => !excludedColumns?.includes(column))
        .some((field: any) => searchRegex.test(row?.[field]?.toString()))
    );
  };

  const requestSearch = (searchValue: string): void => {
    setSearchText(() => searchValue);
    setRows(() => clientSideFilter(searchValue));
  };

  return <QuickSearchField searchText={searchText} requestSearch={requestSearch} enableColumnSearch={enableColumnSearch} />;
};
